const moment = require('moment');
const { formatMoney } = require('accounting');

const onceitProductUrl = 'https://www.onceit.co.nz/products/';
const onceitSaleUrl = 'https://www.onceit.co.nz/sales/';
const colunmns = {
  shippingStatusLabel: { id: 'shippingStatusLabel', label: '' },
  orderStatus: { id: 'orderStatus', enum: true, label: 'Shipping Status', canSort: true },
  shipmentRef: {
    id: 'shipmentRef',
    label: 'Shipping REF',
    canSort: true,
    isLink: true,
    linkType: 'details',
  },
  createdAt: { id: 'createdAt', datetime: true, label: 'Order Created', canSort: true },
  returnCreatedAts: {
    id: 'returnCreatedAts',
    datetime: true,
    label: 'Credit Created',
  },
  shippingEndsAt: { id: 'shippingEndsAt', date: true, label: 'Must Ship By', canSort: false },
  customername: { id: 'customername', label: 'Customer Name', canSort: true },
  skus: { id: 'skus', label: 'SKU', canSort: false },
  barCodes: { id: 'barCodes', label: 'Barcode', canSort: false },
  productShowName: { id: 'productShowName', label: 'Product Name', canSort: false },
  productShowNameWithoutBarCode: {
    id: 'productShowNameWithoutBarCode',
    label: 'Product Name',
    canSort: false,
  },
  quantity: { id: 'quantity', numeric: true, label: 'Quantity', canSort: false },
  cancelledQuantity: {
    id: 'cancelledQuantity',
    numeric: true,
    label: 'Cancelled Qty',
    canSort: false,
  },
  quantityIncludeReturn: {
    id: 'quantityIncludeReturn',
    numeric: true,
    label: 'Quantity',
    canSort: false,
  },
  returnQuantity: {
    id: 'returnQuantity',
    numeric: true,
    label: 'Quantity',
    canSort: false,
  },
  availableQuantity: { id: 'quantity', numeric: true, label: 'Available Qty', canSort: false },
  trackingNumber: { id: 'trackingNumber', label: 'Tracking Number', canSort: false },
  courier: { id: 'courier', numeric: false, label: 'Carrier', canSort: false },
  phone: { id: 'phone', numeric: false, disablePadding: false, label: 'Phone', canSort: true },
  productName: { id: 'productName', numeric: false, label: 'Name', canSort: false },
  productId: { id: 'productId', numeric: false, label: 'Product Id', canSort: false },
  productSKU: { id: 'productSKU', numeric: false, label: 'SKU', canSort: false },
  productBarCode: { id: 'productBarCode', numeric: false, label: 'Barcode', canSort: false },
  isLive: { id: 'isLive', numeric: false, label: 'Live', canSort: false },
  skuId: { id: 'skuId', numeric: false, label: 'id', canSort: false },
  soldAmount: { id: 'soldAmount', numeric: false, label: 'Sold Amount', canSort: false },
  soldQuantity: { id: 'soldQuantity', numeric: false, label: 'Sold Quantity', canSort: false },
  inCheckingQuantity: {
    id: 'inCheckingQuantity',
    numeric: false,
    label: 'InChecking Quantity',
    canSort: false,
  },
  brand: { id: 'brand', label: 'Brand', canSort: false },
  colour: { id: 'colour', label: 'Colour', canSort: false },
  size: { id: 'size', label: 'Size', canSort: false },
  price: { id: 'price', money: true, disablePadding: false, label: 'Price (NZD)', canSort: false },
  cost: {
    id: 'cost',
    money: true,
    disablePadding: false,
    label: 'Cost (NZD GST include)',
    canSort: false,
  },
  costWithoutGst: {
    id: 'costWithoutGst',
    money: true,
    disablePadding: false,
    label: 'Cost (GST excluded)',
    canSort: false,
  },
  currency: {
    id: 'currency',
    label: 'Currency',
    canSort: false,
  },
  supplierIds: { id: 'supplierIds', label: 'Supplier Id' },
  businessName: { id: 'businessName', label: 'Business Name', canSort: true },
  address1: { id: 'address1', label: 'Address 1', canSort: true },
  address2: { id: 'address2', label: 'Address 2', canSort: true },
  suburb: { id: 'suburb', label: 'Suburb', canSort: true },
  city: { id: 'city', label: 'City', canSort: true },
  postcode: { id: 'postcode', label: 'Postcode', canSort: true },
  region: { id: 'region', label: 'Region', canSort: true },
  country: { id: 'country', label: 'Country' },
  signatureRequired: { id: 'signatureRequired', label: 'Signature Required' },
  deliveryInstructions: { id: 'deliveryInstructions', label: 'Special Instructions' },
  returnReasons: { id: 'returnReasons', label: 'Reason' },

  sentBy: { id: 'sentBy', date: true, label: 'Sent By' },
  qtySent: { id: 'qtySent', numeric: true, label: 'Qty Sent' },
  qtyReturned: { id: 'qtyReturned', numeric: true, label: 'Qty Returned' },
  qtyDamaged: { id: 'qtyDamaged', numeric: true, label: 'Qty Damaged' },
  qtyUndersupplied: { id: 'qtyUndersupplied', numeric: true, label: 'Qty Undersupplied' },
  saleIds: { id: 'saleIds', numeric: true, label: 'Sale Id' },
  freightCosts: { id: 'freightCosts', money: true, numeric: true, label: 'Freight Cost Updated' },
  freightCostSubmitted: {
    id: 'freightCostSubmitted',
    numeric: true,
    money: true,
    label: 'Freight Cost Submitted',
  },
  costs: { id: 'costs', money: true, numeric: true, label: 'Unit Cost (GST included)' },
  amounts: { id: 'amounts', money: true, numeric: true, label: 'Unit Cost (GST included)' },
  currencies: { id: 'currencies', label: 'Currency' },
  shippingCost: {
    id: 'shippingCost',
    money: true,
    numeric: true,
    label: 'Quoted Shipping Cost (GST excluded)',
  },
  supplierInputCost: {
    id: 'supplierInputCost',
    money: true,
    numeric: true,
    label: 'True Shipping Cost (GST excluded)',
  },
  costsWithoutGst: {
    id: 'costsWithoutGst',
    money: true,
    numeric: true,
    label: 'Unit Cost (GST excluded)',
  },
  amountsWithoutGst: {
    id: 'amountsWithoutGst',
    money: true,
    numeric: true,
    label: 'Unit Cost (GST excluded)',
  },
  shippingCostWithoutGst: {
    id: 'shippingCostWithoutGst',
    money: true,
    numeric: true,
    label: 'Shipping Cost (GST excluded)',
  },
  notAllReturnedShippingCostWithoutGst: {
    id: 'notAllReturnedShippingCostWithoutGst',
    money: true,
    numeric: true,
    label: 'Shipping Cost (GST excluded)',
  },
  totalCostIncludeReturnWithoutGst: {
    id: 'totalCostIncludeReturnWithoutGst',
    money: true,
    numeric: true,
    label: 'Total Cost (GST excluded)',
  },
  totalCostIncludeReturnWithoutShippingCostWithoutGst: {
    id: 'totalCostIncludeReturnWithoutShippingCostWithoutGst',
    money: true,
    numeric: true,
    label: 'Total Cost (GST excluded)',
  },
  returnTotalCostWithShippingCostWithoutGst: {
    id: 'returnTotalCostWithShippingCostWithoutGst',
    money: true,
    numeric: true,
    label: 'Total Cost (GST excluded)',
  },
  returnTotalCostWithoutShippingCostWithoutGst: {
    id: 'returnTotalCostWithoutShippingCostWithoutGst',
    money: true,
    numeric: true,
    label: 'Total Cost (GST excluded)',
  },
};

const getList = list => list.map(key => colunmns[key]);

const defaultColumnData = getList([
  'shippingStatusLabel',
  'orderStatus',
  'shipmentRef',
  'createdAt',
  'shippingEndsAt',
  'customername',
  'saleIds',
  'productShowName',
  'quantity',
  'cancelledQuantity',
  'shippingCost',
  'courier',
  'trackingNumber',
  'supplierInputCost',
]);

const columnDataForExport = getList([
  'orderStatus',
  'shipmentRef',
  'createdAt',
  'shippingEndsAt',
  'customername',
  'signatureRequired',
  'deliveryInstructions',
  'phone',
  'businessName',
  'address1',
  'address2',
  'suburb',
  'city',
  'postcode',
  'skus',
  'barCodes',
  'saleIds',
  'productShowNameWithoutBarCode',
  'quantity',
  'cancelledQuantity',
  'shippingCost',
  'courier',
  'trackingNumber',
  'supplierInputCost',
]);

const columnDataForStatement = getList([
  'shipmentRef',
  'createdAt',
  'skus',
  'barCodes',
  'productShowNameWithoutBarCode',
  'quantityIncludeReturn',
  'amountsWithoutGst',
  'shippingCostWithoutGst',
  'totalCostIncludeReturnWithoutGst',
]);
const columnDataForStatementReturns = getList([
  'shipmentRef',
  'createdAt',
  'returnCreatedAts',
  'returnReasons',
  'skus',
  'barCodes',
  'productShowNameWithoutBarCode',
  'returnQuantity',
  'amountsWithoutGst',
  'notAllReturnedShippingCostWithoutGst',
  'returnTotalCostWithShippingCostWithoutGst',
]);

const columnDataSendToday = getList([
  'shipmentRef',
  'createdAt',
  'shippingEndsAt',
  'productShowName',
]);

const orderDetails = getList([
  'shipmentRef',
  'orderStatus',
  'createdAt',
  'customername',
  'phone',
  'shippingEndsAt',
  'shippingCost',
  'courier',
  'trackingNumber',
  'supplierInputCost',
]);

const products = getList([
  'productSKU',
  'productBarCode',
  'productName',
  'brand',
  'colour',
  'size',
  'costWithoutGst',
  'currency',
  'quantity',
]);

const columnProducts = getList([
  'skuId',
  'productSKU',
  'productName',
  'isLive',
  'productBarCode',
  'colour',
  'size',
  'costWithoutGst',
  'soldQuantity',
  'inCheckingQuantity',
  'soldAmount',
  'availableQuantity',
  'createdAt',
]);

const address = getList([
  'businessName',
  'address1',
  'address2',
  'suburb',
  'city',
  'postcode',
  'region',
  'country',
  'signatureRequired',
  'deliveryInstructions',
]);

const tracking = getList(['trackingNumber', 'courier']);

const dateTimeFormat = 'YYYY/MM/DD HH:mm';
const dateFormat = 'YYYY/MM/DD';

const valueFormat = (item, value) => {
  if (item) {
    if (item.datetime && !!value) {
      return moment(value).format(dateTimeFormat);
    }
    if (item.date && !!value) {
      return moment(value).format(dateFormat);
    }
    if (item.money) {
      return value === null || value === '' ? '' : parseFloat(value).toFixed(2);
    }
  }
  return value;
};

const shippingTimes = {
  late: 'Late',
  today: 'Must Ship Today',
  coming: 'New',
  sent: 'Sent',
};
const shippingStatus = {
  placed: 'Placed',
  sent: 'Sent',
  cancelled: 'Cancelled',
};

const monthes = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Onceit shipping region ID and Name
 */
const SHIPPING_REGIONS_ID_NAME = {
  '1': 'Auckland',
  '2': 'North Island',
  '3': 'South Island',
  '4': 'Australian Capital Territory',
  '5': 'New South Wales',
  '6': 'Northern Territory',
  '7': 'Queensland',
  '8': 'South Australia',
  '9': 'Tasmania',
  '10': 'Victoria',
  '11': 'Western Australia',
};
/**
 * Onceit shipping region ID and Country
 */
const SHIPPING_REGIONS_ID_COUNTRY = regionId => {
  switch (regionId) {
    case '1':
    case '2':
    case '3':
      return 'New Zealand';
    case '4':
    case '5':
    case '6':
    case '7':
    case '8':
    case '9':
    case '10':
    case '11':
      return 'Australia';
    default:
      return '';
  }
};

/**
 * The rate of get the number of without GST
 * @type {number}
 */
const GST_RATE = 1.15;

module.exports = {
  defaultColumnData,
  orderDetails,
  products,
  address,
  tracking,
  dateTimeFormat,
  valueFormat,
  shippingTimes,
  shippingStatus,
  columnDataSendToday,
  columnDataForExport,
  columnDataForStatement,
  onceitProductUrl,
  onceitSaleUrl,
  columnProducts,
  columnDataForStatementReturns,
  monthes,
  SHIPPING_REGIONS_ID_NAME,
  SHIPPING_REGIONS_ID_COUNTRY,
  GST_RATE,
};



// WEBPACK FOOTER //
// ./src/components/common/constants.js